import { Color } from 'three';
import { CONFIG } from '../config.js';

const BG_STABLE = new Color(0x02040a);
const BG_SCORCH = new Color(0x120806);
const BG_FREEZE = new Color(0x040a12);

/**
 * Soft visual grading by era key.
 */
export function applyEraLook({ scene, bloom, atmosphere, horizon, eraKey, config = CONFIG }) {
  const bg = scene.background;
  let target = BG_STABLE;
  let bloomStrength = config.BLOOM_STRENGTH;
  let atmHex = 0x4a90b0;
  let rimHex = 0x80c0e0;
  let atmOpacity = 0.05;

  if (eraKey === 'scorching') {
    target = BG_SCORCH;
    bloomStrength = config.BLOOM_STRENGTH * 1.08;
    atmHex = 0xff8040;
    rimHex = 0xffb080;
    atmOpacity = 0.08;
  } else if (eraKey === 'freezing') {
    target = BG_FREEZE;
    bloomStrength = config.BLOOM_STRENGTH * 0.92;
    atmHex = 0x70b0ff;
    rimHex = 0x9ed7ff;
    atmOpacity = 0.07;
  }

  if (bg && bg.isColor) bg.lerp(target, 0.04);
  if (bloom) bloom.setStrength(bloomStrength);
  if (atmosphere) {
    atmosphere.setTint(atmHex);
    atmosphere.setOpacity(atmOpacity);
  }
  if (horizon) horizon.setTint(rimHex);
}
